import logo from "./media/logo.png";
import logoPost from "./media/logoPost.png";
import ceLogo from "./media/ce.png";
import footerLogo from "./media/powered-by-healo.png";
import backgroundImage from "./media/background.jpg";
import constants from "../../../../common/constants";

import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "epassi",
  image: logo,
  imagePost: logoPost,
  imageQA: logo,
  ceLogo: ceLogo,
  footerImage: footerLogo,
  secondaryBackground: {
    backgroundColor: "rgba(201, 222, 219, 0.95)",
    gradientColors: ["rgba(201, 222, 219, 0.95)", "rgba(201, 222, 219, 0.85)"]
  },
  backGroundVideo: null,
  appBackground: {
    url: backgroundImage
  },
  baseClass: "brand-epassi",
  domains: [
    "http://localhost:4002",
    "https://dev-epassi.healo.app",
    "https://stg-epassi.healo.app",
    "https://epassi.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1112 : 1106,
  ssnEnabled: false,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/epassi/settings.js